module.exports = __webpack_public_path__ + "static/policy_book1_2@2x-53786ee0b357ffbd4f550ae221006bcc.png";